import { FormGroup, GeoAddress, GoogleAddressForm, YandexAddressFormV2 } from '@agro-club/agroclub-shared'
import env from 'env'
import { FormikFieldsType } from 'modules/domain/types'
import { FC, ReactNode, useState } from 'react'
import { useTranslation } from 'react-i18next'

export interface FormMapProps {
  formik?: FormikFieldsType
  handlerMap: (data: any) => void
  disabled?: boolean
  children?: ReactNode
  required?: boolean
  address?: GeoAddress | null
}

const centerUS = { lat: 38.9072, lng: -77.0369 }

export const FormMap: FC<FormMapProps> = ({ formik, handlerMap, disabled, children, required, address }) => {
  const { t } = useTranslation('user')
  const [valueMaps, setValueMaps] = useState<string | undefined>()
  const yandexKey = env.REACT_APP_YA_MAPS_API_KEY
  const yandexSuggestKey = env.REACT_APP_YA_MAPS_SUGGEST_API_KEY
  const googleKey = env.REACT_APP_GOOGLE_MAPS_API_KEY
  const googleMapId = env.REACT_APP_GOOGLE_MAPS_MAP_ID

  return (
    <>
      {googleKey ? (
        <FormGroup
          label={t('form.fields.address')}
          error={formik && formik.errors.addresses?.[0].address}
          required={required}
        >
          <GoogleAddressForm
            defaultCenter={centerUS}
            mapId={googleMapId}
            apikey={googleKey}
            onChange={handlerMap}
            size="middle"
            address={address || undefined}
            showMap={!disabled}
            disabled={disabled}
            invalid={formik && (formik.errors.addresses?.[0].address || formik.errors.main_address?.[0])}
          >
            {children}
          </GoogleAddressForm>
        </FormGroup>
      ) : (
        <FormGroup label={t('form.fields.address')} error={formik && formik.errors.addresses} required={required}>
          <YandexAddressFormV2
            suggest_apikey={yandexSuggestKey}
            onChange={handlerMap}
            setValue={setValueMaps}
            value={valueMaps}
            apikey={yandexKey}
            size="middle"
            showMap={!disabled}
            disabled={disabled}
          >
            {children}
          </YandexAddressFormV2>
        </FormGroup>
      )}
    </>
  )
}
